<template>
    <router-link :to="href" :active-class="activeClass" :exact-active-class="exactActiveClass" :exact="matchExact">
        <slot></slot>
    </router-link>
</template>
<script>
export default {
    props: ['href', 'activeClass', 'exactActiveClass'],
    data() {
        return {
            matchExact: this.href == '/',
        }
    }
}
</script>



// WEBPACK FOOTER //
// ../default-js/js/components/common/LinkElements/RouterLink.vue